module.exports = __webpack_public_path__ + "media/images/konintodoke/top_mv/konintodoke00010-48e903471033bd658be4c2a3e10b2ca4.jpg";